import { formatMonthYear } from '@common/neo.tax';
import { AlertModalLayout, Button, GeneralFormError, Stack } from '@ui-components/neo.tax';
import { ReactElement, useState } from 'react';

import { useAscContext } from '@neo.tax/asc/context';

import { useAscProjectApprovalModalAnalyticIds } from './hooks';

interface ResetApprovalConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => Promise<void>;
  loading: boolean;
}

export const ResetApprovalConfirmationModal = ({
  loading,
  onClose,
  onConfirm,
}: ResetApprovalConfirmationModalProps): ReactElement => {
  const { period } = useAscContext();
  const [errorMessage, setErrorMessage] = useState<string>();
  const { resetCancelBtnId, resetConfirmBtnId } = useAscProjectApprovalModalAnalyticIds();

  const formattedMonthYear = formatMonthYear(period.startMonthYear);

  const handleConfirm = async (): Promise<void> => {
    try {
      setErrorMessage(undefined);
      await onConfirm();
    } catch (error) {
      setErrorMessage((error instanceof Error && error.message) || 'An unexpected error occurred. Please try again.');
    }
  };

  const handleCancel = (): void => {
    setErrorMessage(undefined);
    onClose();
  };

  return (
    <Stack direction="column" padding={6}>
      <AlertModalLayout
        title="Reset Approval"
        copy={`Are you sure you want to reset the approval? This will clear all approvals from ${formattedMonthYear} onward.`}
        trailingContent={
          <>
            <Button id={resetCancelBtnId} size="base" variant="white" rounded="regular" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              id={resetConfirmBtnId}
              disabled={loading}
              rounded="regular"
              size="base"
              type="submit"
              variant="rsbry"
              onClick={handleConfirm}
            >
              {loading ? 'Resetting...' : 'Reset'}
            </Button>
          </>
        }
      >
        <GeneralFormError error={!!errorMessage}>{errorMessage}</GeneralFormError>
      </AlertModalLayout>
    </Stack>
  );
};
